var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1143 8.4375H10.339V5.76562C10.339 5.68828 10.2732 5.625 10.1929 5.625H9.31648C9.23615 5.625 9.17041 5.68828 9.17041 5.76562V8.4375H6.39509C6.31475 8.4375 6.24902 8.50078 6.24902 8.57812V9.42188C6.24902 9.49922 6.31475 9.5625 6.39509 9.5625H9.17041V12.2344C9.17041 12.3117 9.23615 12.375 9.31648 12.375H10.1929C10.2732 12.375 10.339 12.3117 10.339 12.2344V9.5625H13.1143C13.1946 9.5625 13.2604 9.49922 13.2604 9.42188V8.57812C13.2604 8.50078 13.1946 8.4375 13.1143 8.4375Z",
    fill: "#C71C8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75509 1.125C5.23789 1.125 1.5752 4.65117 1.5752 9C1.5752 13.3488 5.23789 16.875 9.75509 16.875C14.2723 16.875 17.935 13.3488 17.935 9C17.935 4.65117 14.2723 1.125 9.75509 1.125ZM9.75509 15.5391C6.00476 15.5391 2.96286 12.6105 2.96286 9C2.96286 5.38945 6.00476 2.46094 9.75509 2.46094C13.5054 2.46094 16.5473 5.38945 16.5473 9C16.5473 12.6105 13.5054 15.5391 9.75509 15.5391Z",
    fill: "#C71C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRound);
export default __webpack_public_path__ + "static/media/add_round.97d1078f5ef4c2979aead0b8223eb2e3.svg";
export { ForwardRef as ReactComponent };